import { Form } from "antd"
import { TextTag as Text } from "../../atoms"
import { OtpInput } from "../../molecules/OtpInput"
import { withFormik } from "formik"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { verifyOtp, loginByMobile } from "../../redux/actionCreators/auth"
import { OtpValidation } from "../../validationSchema/OtpValidation"
import _ from "../../utils/lodashUtils"
import "./OtpVerificationPage.scss"
import otplogo from "../../assets/images/otp-mobile.svg"
import usaFlag from "../../assets/images/usa.svg"
import indiaFlag from "../../assets/images/india.svg"
import { formatPhoneNumber } from "../../utils/helpers"
import {
  OTP_LABEL,
  OTP_SCREEN_MSG,
  OTP_PHONE_LABEL,
  OTP_RESEND_MSG,
  RESEND_AGAIN,
} from "../../constants/messages"
import { OTP_VERIFY_FAILED } from "../../constants/notificationMsg"

const S = (props) => {
  const { values, handleSubmit, mobileVerificationFailed, verifyOtp } = props
  const [otpError, setOtpError] = React.useState(false)
  const [prevOtp, setPrevOtp] = React.useState()
  const otpRef = React.useRef()

  const clearInput = () => {
    if (otpRef.current) otpRef.current.clearInputValues()
  }

  React.useEffect(() => {
    if (mobileVerificationFailed) {
      setOtpError(mobileVerificationFailed)
    }
  }, [mobileVerificationFailed])

  const resendOtp = () => {
    values.otp = ""
    props.loginByMobile(values, false)
    clearInput()
  }

  const handleOtpSubmit = (otpValue) => {
    if (otpValue === prevOtp && mobileVerificationFailed) {
      setOtpError(true)
    }
    verifyOtp({ mobile: values.mobile, otp: otpValue }).then((response) => {
      clearInput()
    })
    setPrevOtp(otpValue)
    handleSubmit()
  }

  let phone = formatPhoneNumber(values.mobile)
  const flagPath = () => {
    return phone.intlCode === "+1" ? usaFlag : indiaFlag
  }

  const renderOTPVerificationStatusText = () => {
    if (otpError && mobileVerificationFailed) {
      return (
        <Text textType="smallTextSecondary" className="label-error">
          {OTP_VERIFY_FAILED}
        </Text>
      )
    } else {
      return ""
    }
  }

  const onChangeOTP = () => setOtpError(false)

  return (
    <div id="OtpVerificationPage">
      <form onSubmit={handleSubmit}>
        <div>
          <div className="otp-message-box">
            <div>
              <img src={otplogo} alt="mobile-img" />
            </div>
            <div className="otp-message">
              <Text textType="tagline">{OTP_SCREEN_MSG}</Text>{" "}
            </div>
          </div>
          <div className="otp-box">
            <div className="half-containers otp-box-top">
              <div className="otp-mobile">
                <div className="telephone">
                  <div className="label">
                    <Text textType="default">{OTP_PHONE_LABEL}</Text>
                  </div>
                  <div className="phone-box">
                    <div className="selected-flag">
                      <img
                        src={flagPath()}
                        className="flag-icon"
                        alt="flag icon"
                      />
                      <Text textType="pageHeading">{phone.intlCode}</Text>
                    </div>
                    <Text textType="pageHeading">{phone.telephoneNumber}</Text>
                  </div>
                  <div className="separator"> </div>
                </div>
              </div>
            </div>
            <div className="half-containers">
              <div className="otp-bottom-box ">
                <div id="contactYouOtp">
                  <Text className="info-label" textType="default">
                    {OTP_LABEL}
                  </Text>
                  <OtpInput
                    otpLength={4}
                    onOtpSubmit={handleOtpSubmit}
                    ref={otpRef}
                    onChange={onChangeOTP}
                  ></OtpInput>
                </div>
                <div className="error-msg">
                  {renderOTPVerificationStatusText()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Form.Item>
          <Text textType="smallTextPrimary" className="resend-otp">
            {OTP_RESEND_MSG}
            <a className="resend-otp-btn" onClick={resendOtp}>
              {RESEND_AGAIN}
            </a>
          </Text>
        </Form.Item>
      </form>
    </div>
  )
}

const OtpVerificationPage = withFormik({
  enableReinitialize: true,
  validationSchema: OtpValidation,
  mapPropsToValues: (props) => ({
    mobile: _.get(props.user, "phone_number", ""),
    otp: "",
  }),
})(S)
const mapStateToProps = (state) => ({
  user: state.auth.user,
  mobileVerificationFailed: _.get(state.auth, "mobileVerificationFailed"),
})
export default connect(mapStateToProps, { verifyOtp, loginByMobile })(
  withRouter(OtpVerificationPage)
)
